<template>
    <v-container class="pa-12">
        <v-card class="pl-16 pr-16 pt-8 pb-16">
            <v-card-title>
                <v-row>
                    <v-col cols="6" md="6">
                        <h3>Quotation / Fee Estimate</h3>
                    </v-col>
                    <v-col cols="6" md="6">
                        <v-row>
                            <v-col class="text-right" cols="12" md="12">
                                <h5>No. {{ doc.doc_no || ((docType === "fixed" ? "QT-" : "EST-") +
                                    "(ออกอัตโนมัติเมื่อบันทึก)") }}</h5>
                                <h5>Date {{ doc.doc_date_show }}</h5>
                                <v-chip x-small :color="statusColor" dark class="mt-1">{{ statusLabel }}</v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-btn-toggle v-model="docType" mandatory dense class="mb-4 ml-1 doctype-toggle"
                :disabled="!docTypeEditable">
                <v-btn small value="fixed">💰 Fixed Price (Quotation)</v-btn>
                <v-btn small value="estimate">⏱️ Estimate Fee</v-btn>
            </v-btn-toggle>

            <div v-if="docType === 'estimate'" class="wf-alert wf-alert-warn">
                ⚠️ เอกสารนี้เป็น <b>การประมาณการค่าบริการเบื้องต้น (Non-binding Estimate)</b>
                มิใช่ใบเสนอราคาที่มีผลผูกพันทางกฎหมาย และจะไม่ถูกนับรวมใน Pipeline หลักจนกว่าจะมี Invoice จริง
            </div>

            <!-- ===== Header fields: แก้ไขได้ทั้ง Draft และ Submitted ===== -->
            <v-row class="row1 mt-3 pt-3">
                <v-col cols="12" md="6">
                    <v-autocomplete v-model="doc.client_code" :items="clientOptions" item-text="code" item-value="code"
                        label="Client Code" outlined dense :disabled="!headerEditable"
                        @change="(val) => onClientSelect(val, 'code')"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                    <v-autocomplete v-model="doc.client_name" :items="clientOptions" item-text="name" item-value="name"
                        label="Client Name" outlined dense :disabled="!headerEditable"
                        @change="(val) => onClientSelect(val, 'name')"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
                <v-col cols="12" md="10">
                    <v-text-field v-model="doc.client_address" label="Client Address" outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
                <v-col cols="12" md="10">
                    <v-text-field v-model="doc.invoice_address" label="Invoice Address" outlined dense
                        background-color="#F5F5F5" disabled placeholder="auto-fill จาก Client Master"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
                <v-col cols="12" md="3">
                    <v-text-field v-model="doc.tax_id" label="Tax ID" outlined dense background-color="#F5F5F5"
                        disabled></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="doc.branch" label="Branch" outlined dense background-color="#F5F5F5"
                        disabled></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="doc.payment_term" label="Payment Term (Day)" outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select :items="currency_list" v-model="doc.currency" item-text="curr" item-value="curr"
                        label="Currency" outlined dense hide-details background-color="#F5F5F5" disabled></v-select>
                </v-col>
            </v-row>

            <v-row class="heightsize70formadvance">
                <v-col cols="12" sm="3">
                    <v-text-field v-model="doc.vat_percent" label="Vat rate (%)" outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
                <v-col cols="6" md="3">
                    <v-text-field v-model="doc.attention" label="Attention" outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
                <v-col cols="6" md="3">
                    <v-text-field v-model="doc.contact_position" label="Contact Position" outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
            </v-row>
            <!-- <v-row class="heightsize70formadvance">
                <v-col cols="12" md="4">
                    <v-text-field v-model="doc.po_no" label="PO No." outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-menu v-model="menuPoDate" :close-on-content-click="false" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="doc.po_date" label="PO Date" append-icon="mdi-calendar" readonly
                                outlined dense :disabled="!headerEditable" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
<v-date-picker v-model="doc.po_date" @input="menuPoDate = false"></v-date-picker>
</v-menu>
</v-col>
<v-col cols="12" sm="4">
    <v-menu v-model="menuDeliveryDate" :close-on-content-click="false" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="doc.delivery_date" label="Delivery Date" append-icon="mdi-calendar"
                                readonly outlined dense :disabled="!headerEditable" v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
        <v-date-picker v-model="doc.delivery_date" @input="menuDeliveryDate = false"></v-date-picker>
    </v-menu>
</v-col>
</v-row> -->

            <v-row class="row1 mt-3 pt-3">
                <v-col cols="12" md="12">
                    <v-textarea v-model="doc.additional_info" solo label="Additional information"
                        :disabled="!headerEditable" auto-grow rows="4"></v-textarea>
                </v-col>
            </v-row>
            <v-row class="row1 mt-3 pt-3">
                <v-col cols="12" md="3">
                    <input ref="fileInput" type="file" accept="application/pdf,.pdf" multiple style="display:none"
                        @change="onFileSelected" />
                    <v-btn :disabled="!headerEditable" class="btnuploadfile" elevation="7"
                        @click="$refs.fileInput.click()">
                        <v-icon left dark>mdi-cloud-upload</v-icon>Upload file
                    </v-btn>
                </v-col>
                <v-col cols="12" md="9">
                    <div class="file-list">
                        <div v-for="f in uploadedFiles" :key="f.id" class="file-card">
                            <div class="file-card-main" @click="previewFile(f)">
                                <v-icon color="#D32F2F" size="28">mdi-file-pdf-box</v-icon>
                                <span class="file-card-name" :title="f.name">{{ f.name }}</span>
                            </div>
                            <v-btn v-if="headerEditable" icon small class="file-card-delete" @click="removeFile(f.id)">
                                <v-icon small>mdi-delete-outline</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <!-- ===== Fixed Price item table ===== -->
            <template v-if="docType === 'fixed'">
                <div class="wf-alert wf-alert-info mt-8">
                    <v-icon small color="#0d47a1">mdi-information-outline</v-icon>
                    VAT rate {{ Number(doc.vat_percent).toFixed(2) }}% จะใช้กับรายการที่เปิด 'คิด VAT' เท่านั้น
                </div>
                <div class="d-flex justify-space-between align-center mt-4 mb-1">

                    <h3 class="text-subtitle-1 mb-0">รายการสินค้า/บริการ</h3>

                </div>


                <v-card outlined tile>
                    <v-simple-table dense>
                        <thead>
                            <tr class="bg-colorth">
                                <th class="texttablehcenter" style="width:24px"></th>
                                <th class="texttablehcenter" style="width:36px">No.</th>
                                <th class="texttablehcenter" style="min-width:150px">ชื่อสินค้า/รายละเอียด</th>
                                <th class="texttablehcenter text-right" style="width:80px">จำนวน</th>
                                <th class="texttablehcenter" style="width:90px">หน่วย</th>
                                <th class="texttablehcenter text-right" style="width:130px">ราคาต่อหน่วย</th>
                                <th class="texttablehcenter text-right" style="width:130px">ราคาก่อน VAT</th>
                                <th class="texttablehcenter" style="width:130px">
                                    <div>คิด VAT</div>
                                    <v-checkbox :input-value="allFixedVatSelected"
                                        :indeterminate="fixedVatIndeterminate" dense hide-details dark
                                        class="ma-0 pa-0 d-inline-flex select-all-checkbox" label="เลือกทั้งหมด"
                                        @change="toggleAllVat('fixed', $event)"></v-checkbox>
                                </th>
                                <th class="texttablehcenter text-right" style="width:110px">VAT</th>
                                <th class="texttablehcenter text-right" style="width:130px">ราคารวม</th>
                                <th class="texttablehcenter" style="width:32px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in fixedRows" :key="row.id" :data-row-id="'fixed-' + row.id"
                                :draggable="itemsEditable" @dragstart="itemsEditable && onDragStart('fixed', row.id)"
                                @dragover.prevent="itemsEditable && onDragOver('fixed', row.id, $event)"
                                @drop="itemsEditable && onDrop('fixed', row.id, $event)" @dragend="onDragEnd"
                                :class="dragRowClass('fixed', row.id)">
                                <td class="drag-handle" v-if="itemsEditable">⇅</td>
                                <td v-else></td>
                                <td>{{ idx + 1 }}</td>

                                <td>
                                    <div class="item-picker">
                                        <v-combobox v-model="row.name" :items="filterMaster(row.searchText)"
                                            :search-input.sync="row.searchText" item-text="name" dense hide-details
                                            outlined :disabled="!itemsEditable" placeholder="ชื่อสินค้า"
                                            @input="(val) => onNameInput('fixed', row, val)">
                                            <template v-slot:item="{ item }">
                                                <span
                                                    :class="isAddNewItem(item) ? 'blue--text font-weight-medium' : ''">{{
                                                        item }}</span>
                                            </template>
                                        </v-combobox>
                                    </div>
                                    <v-textarea v-model="row.detail"
                                        :placeholder="row.name ? 'รายละเอียด (Shift+Enter ขึ้นบรรทัดใหม่)' : 'กรุณาเลือกชื่อสินค้าก่อน'"
                                        dense hide-details rows="1" auto-grow solo flat class="detail-input mt-1"
                                        :disabled="!itemsEditable || !row.name"
                                        @keydown="onDetailKeydown($event, 'fixed', row)"></v-textarea>
                                </td>
                                <td class="text-right">
                                    <v-text-field v-model.number="row.qty" type="number" dense hide-details outlined
                                        :disabled="!itemsEditable"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field v-model="row.unit" dense hide-details outlined
                                        :disabled="!itemsEditable"></v-text-field>
                                </td>
                                <td class="text-right">
                                    <v-text-field v-model.number="row.price" type="number" dense hide-details outlined
                                        :disabled="!itemsEditable"></v-text-field>
                                </td>
                                <td class="text-right">{{ fmt(row.qty * row.price) }}</td>
                                <td class="text-center vat-switch-cell">
                                    <v-switch class="vat-switch" v-model="row.applyVat" dense hide-details inset
                                        :disabled="!itemsEditable" :label="row.applyVat ? 'คิด VAT' : 'ไม่คิด VAT'"
                                        color="#1565C0"></v-switch>
                                </td>
                                <td class="text-right">{{ fmt(row.applyVat ? (row.qty * row.price) *
                                    (Number(doc.vat_percent) / 100) : 0) }}</td>
                                <td class="text-right font-weight-medium">
                                    {{ fmt(row.applyVat ? (row.qty * row.price) * (1 + Number(doc.vat_percent) / 100) :
                                        (row.qty * row.price)) }}
                                </td>
                                <td>
                                    <v-icon v-if="itemsEditable" small color="error"
                                        @click="delRow('fixed', row.id)">mdi-delete-outline</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                <v-btn v-if="itemsEditable" small color="#90CAF9" class="mt-2" @click="addRow('fixed')">➕
                    เพิ่มแถว</v-btn>

                <!-- Total/VAT/Grand Total: คำนวณ real-time ตาม Business Logic Note 5 -->
                <div class="d-flex justify-space-between align-center mt-3 mb-2 flex-wrap">
                    <span class="text-body-2 grey--text">
                        <v-icon small color="blue" class="mt-n1">mdi-information-outline</v-icon>
                        {{ fixedTotals.rowCount }} รายการ • คิด VAT {{ fixedTotals.vatCount }} • ไม่คิด VAT {{
                            fixedTotals.noVatCount }}
                    </span>
                </div>

                <v-row justify="end">
                    <v-col cols="12" md="5">
                        <v-card outlined class="summary-card pa-4">
                            <div class="summary-title font-weight-bold mb-3">สรุปยอด</div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">ยอดรวมก่อน VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.total) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">รายการที่ติด VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.vatBase) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">รายการที่ไม่ติด VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.noVatBase) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">VAT {{ Number(doc.vat_percent).toFixed(2) }}%</div>
                                <div class="summary-value">{{ fmt(fixedTotals.vat) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row summary-total-box">
                                <div class="summary-label font-weight-bold">ยอดสุทธิ</div>
                                <div class="summary-value text-h6 font-weight-bold primary--text">{{
                                    fmt(fixedTotals.grandTotal) }} {{
                                        doc.currency }}</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

            <!-- ===== Estimate Fee item table ===== -->
            <template v-else>
                <div class="wf-alert wf-alert-info mt-8">
                    <v-icon small color="#0d47a1">mdi-information-outline</v-icon>
                    VAT rate {{ Number(doc.vat_percent).toFixed(2) }}% จะใช้กับรายการที่เปิด 'คิด VAT' เท่านั้น
                </div>
                <div class="d-flex justify-space-between align-center mt-4 mb-1">

                    <h3 class="text-subtitle-1 mb-0">รายการบริการ (ประมาณการ)</h3>

                </div>

                <v-card outlined tile>
                    <v-simple-table dense>
                        <thead>
                            <tr class="bg-colorth">
                                <th class="texttablehcenter" style="width:24px"></th>
                                <th class="texttablehcenter" style="width:36px">No.</th>
                                <th class="texttablehcenter" style="min-width:260px">ชื่อสินค้า/รายละเอียด</th>
                                <th class="texttablehcenter text-right" style="width:180px">(Rate/Hr.) / Estimate Fees
                                </th>
                                <th class="texttablehcenter text-right" style="width:130px">ราคาก่อน VAT</th>
                                <th class="texttablehcenter" style="width:130px">
                                    <div>คิด VAT</div>
                                    <v-checkbox :input-value="allEstimateVatSelected"
                                        :indeterminate="estimateVatIndeterminate" dense hide-details dark
                                        class="ma-0 pa-0 d-inline-flex select-all-checkbox" label="เลือกทั้งหมด"
                                        @change="toggleAllVat('estimate', $event)"></v-checkbox>
                                </th>
                                <th class="texttablehcenter text-right" style="width:110px">VAT</th>
                                <th class="texttablehcenter text-right" style="width:130px">ราคารวม</th>
                                <th class="texttablehcenter" style="width:32px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in estimateRows" :key="row.id" :data-row-id="'estimate-' + row.id"
                                :draggable="itemsEditable" @dragstart="itemsEditable && onDragStart('estimate', row.id)"
                                @dragover.prevent="itemsEditable && onDragOver('estimate', row.id, $event)"
                                @drop="itemsEditable && onDrop('estimate', row.id, $event)" @dragend="onDragEnd"
                                :class="dragRowClass('estimate', row.id)">
                                <td class="drag-handle" v-if="itemsEditable">⇅</td>
                                <td v-else></td>
                                <td>{{ idx + 1 }}</td>
                                <td>
                                    <div class="item-picker">
                                        <v-combobox v-model="row.name" :items="filterMaster(row.searchText)"
                                            :search-input.sync="row.searchText" item-text="name" dense hide-details
                                            outlined :disabled="!itemsEditable" placeholder="ชื่อสินค้า/บริการ"
                                            @input="(val) => onNameInput('estimate', row, val)">
                                            <template v-slot:item="{ item }">
                                                <span
                                                    :class="isAddNewItem(item) ? 'blue--text font-weight-medium' : ''">{{
                                                        item }}</span>
                                            </template>
                                        </v-combobox>
                                    </div>
                                    <v-textarea v-model="row.detail"
                                        :placeholder="row.name ? 'รายละเอียด (Shift+Enter ขึ้นบรรทัดใหม่)' : 'กรุณาเลือกชื่อสินค้าก่อน'"
                                        dense hide-details rows="1" auto-grow solo flat class="detail-input mt-1"
                                        :disabled="!itemsEditable || !row.name"
                                        @keydown="onDetailKeydown($event, 'estimate', row)"></v-textarea>
                                </td>
                                <td class="text-right">
                                    <v-text-field v-model="row.rate" dense hide-details outlined
                                        :disabled="!itemsEditable" type="number"></v-text-field>
                                </td>
                                <td class="text-right">{{ fmt(row.rate) }}</td>
                                <td class="text-center vat-switch-cell">
                                    <v-switch class="vat-switch" v-model="row.applyVat" dense hide-details inset
                                        :disabled="!itemsEditable" :label="row.applyVat ? 'คิด VAT' : 'ไม่คิด VAT'"
                                        color="#1565C0"></v-switch>
                                </td>
                                <td class="text-right">{{ fmt(row.applyVat ? (Number(row.rate) || 0) *
                                    (Number(doc.vat_percent) / 100) : 0) }}</td>
                                <td class="text-right font-weight-medium">
                                    {{ fmt(row.applyVat ? (Number(row.rate) || 0) * (1 + Number(doc.vat_percent) / 100)
                                        :
                                        (Number(row.rate) || 0)) }}
                                </td>
                                <td>
                                    <v-icon v-if="itemsEditable" small color="error"
                                        @click="delRow('estimate', row.id)">mdi-delete-outline</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                <v-btn v-if="itemsEditable" small color="#90CAF9" class="mt-2" @click="addRow('estimate')">➕
                    เพิ่มแถว</v-btn>



                <div class="d-flex justify-space-between align-center mt-3 mb-2 flex-wrap">
                    <span class="text-body-2 grey--text">
                        <v-icon small color="blue" class="mt-n1">mdi-information-outline</v-icon>
                        {{ estimateTotals.rowCount }} รายการ • คิด VAT {{ estimateTotals.vatCount }} • ไม่คิด VAT {{
                            estimateTotals.noVatCount }}
                    </span>
                </div>

                <v-row justify="end">
                    <v-col cols="12" md="5">
                        <v-card outlined class="summary-card pa-4">
                            <div class="summary-title font-weight-bold mb-3">สรุปยอด</div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">ยอดรวมก่อน VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.total) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">รายการที่ติด VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.vatBase) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">รายการที่ไม่ติด VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.noVatBase) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">VAT {{ Number(doc.vat_percent).toFixed(2) }}%</div>
                                <div class="summary-value">{{ fmt(estimateTotals.vat) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row summary-total-box">
                                <div class="summary-label font-weight-bold">ยอดสุทธิ</div>
                                <div class="summary-value text-h6 font-weight-bold primary--text">{{
                                    fmt(estimateTotals.grandTotal) }}
                                    {{ doc.currency }}</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="12" md="6">
                        <v-text-field v-model="doc.not_to_exceed_cap"
                            label="วงเงินไม่เกิน (Not-to-Exceed Cap) — Optional" placeholder="ไม่ระบุ = ไม่จำกัดวงเงิน"
                            outlined dense :disabled="!itemsEditable"></v-text-field>
                    </v-col>
                </v-row>
                <!-- <div class="wf-alert wf-alert-info">
                    ℹ️ ไม่มีการคำนวณ Grand Total อัตโนมัติ เนื่องจากแต่ละรายการอาจใช้ฐานราคาต่างกัน —
                    ยอดที่เรียกเก็บจริงจะคำนวณตอนออก Invoice แต่ละรอบ
                </div> -->
            </template>
            <v-row class="mt-2 mb-2" v-if="isEditMode">
                <v-col align="right" cols="12">
                    <v-btn outlined color="#1565C0" @click="onPrint">
                        🖨️ Print / PDF
                    </v-btn>
                </v-col>
            </v-row>
            <br />
            <hr />
            <br />
            <div>
                <v-row>
                    <v-col align="center" cols="12" md="12">
                        <v-btn outlined class="mr-5" @click="getBackList()">
                            Back
                        </v-btn>
                        <v-btn class="mr-5 buttonblue" :disabled="isLocked || doc.status !== 'Draft'"
                            @click="onSaveDraft">
                            Save Draft
                        </v-btn>
                        <v-btn v-if="isEditMode" depressed class="mr-5 buttonblue" :disabled="isLocked"
                            @click="onSubmit">
                            Submit
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row v-if="showDelete">
                    <v-col align="end" cols="12" md="12">
                        <v-btn depressed class="buttonred" @click="dialogDelete = true">
                            Delete form
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-dialog v-model="dialogDelete" max-width="400px">
            <v-card style="padding-top: 30px; padding-bottom: 30px;">
                <v-card-title style="padding-bottom: 20px;">
                    <v-row justify="center">
                        <span class="red--text text-h5 ju">Delete this item?</span>
                    </v-row>
                </v-card-title>
                <br />
                <v-card-subtitle>
                    <v-row justify="center">
                        <span class="black--text">This action cannot be undone.</span>
                    </v-row>
                </v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed width="100" class="mr-3 buttonblue" color="red" @click="confirmDelete">
                        Save
                    </v-btn>
                    <v-btn depressed outlined width="100" color="red" @click="dialogDelete = false">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3500">
            {{ snackbar.text }}
        </v-snackbar>

        <add-product-dialog v-model="showAddProductDialog" :prefill-name="addProductPrefill"
            @saved="onProductSaved"></add-product-dialog>
        <v-dialog v-model="dialogSelectTitle" scrollable max-width="35%">
            <v-card class="pa-4">
                <v-card-text>
                    <div class="d-flex align-center mb-0 mt-5">
                        <span class="text-h5 font-weight-bold">Select Company</span>
                    </div>
                    <v-radio-group v-model="dialogSelectClientInfo" column>
                        <v-radio label="DEJ-UDOM & ASSOCIATES LIMITED" value="1" class="mb-2"></v-radio>
                        <v-radio label="สำนักงานกฎหมาย เดชอุดม แอนด์แอสโซซิเอทส์" value="3" class="mb-2"></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-card-actions style="margin-top: -30px;">
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                            <v-btn color="#106a94" large rounded dark elevation="0" @click="confirmPrint" block>
                                Print Preview
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-btn color="#fc1526" large rounded dark elevation="0" @click="dialogSelectTitle = false"
                                block>
                                Cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />
        <v-dialog v-model="showVatDetailDialog" max-width="820px" scrollable content-class="vat-dialog-card">
            <v-card class="pa-6">
                <div class="d-flex justify-space-between align-start mb-1">
                    <div>
                        <div class="text-h5 font-weight-bold">รายละเอียดการคำนวณ VAT</div>
                        <div class="text-body-2 grey--text mt-1">คำนวณจากมูลค่ารายการก่อน VAT</div>
                    </div>
                    <v-btn icon @click="showVatDetailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-card outlined class="mt-4 vat-table-card">
                    <v-simple-table dense class="vat-detail-table">
                        <thead>
                            <tr>
                                <th>รายการ</th>
                                <th class="text-center">มูลค่าก่อน VAT<br />(THB)</th>
                                <th class="text-center">อัตรา VAT</th>
                                <th class="text-center">VAT<br />(THB)</th>
                                <th class="text-center">รวมหลัง VAT<br />(THB)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in vatDetailRows" :key="idx">
                                <td>{{ row.name }}</td>
                                <td class="text-right">{{ fmt(row.base) }}</td>
                                <td class="text-center">
                                    <v-chip v-if="row.applyVat" x-small color="#E3F2FD" text-color="#1565C0">{{
                                        row.vatRate
                                        }}%</v-chip>
                                    <span v-else class="grey--text text-caption">ไม่คิด VAT</span>
                                </td>
                                <td class="text-right">
                                    <div class="font-weight-medium">{{ fmt(row.vatAmount) }}</div>
                                    <div v-if="row.applyVat" class="text-caption grey--text">
                                        {{ fmt(row.base) }} × {{ row.vatRate }}%
                                    </div>
                                </td>
                                <td class="text-right font-weight-medium">{{ fmt(row.afterVat) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>

                <!-- ✅ สรุปยอดแบบ card เหมือนหน้าหลัก -->
                <v-card outlined class="summary-card vat-summary-card pa-4 mt-4">
                    <div class="d-flex align-center summary-row mb-2">
                        <div class="summary-label">
                            <div>ยอดรายการทั้งหมด</div>
                            <div class="text-caption grey--text">รวมทุกแถวในตาราง</div>
                        </div>
                        <div class="summary-value">{{ fmt(vatDetailTotals.total) }} {{ doc.currency }}</div>
                    </div>

                    <div class="d-flex align-center summary-row mb-2">
                        <div class="summary-label">
                            <div>VAT รวม</div>
                            <div class="text-caption grey--text">เฉพาะรายการที่เลือกคิด VAT</div>
                        </div>
                        <div class="summary-value">{{ fmt(vatDetailTotals.vat) }} {{ doc.currency }}</div>
                    </div>

                    <div class="d-flex align-center summary-row summary-total-box">
                        <div class="summary-label">
                            <div class="font-weight-bold">ยอดชำระทั้งหมด</div>
                            <div class="text-caption grey--text">รวม VAT แล้ว</div>
                        </div>
                        <div class="summary-value vat-grand-total font-weight-bold primary--text">{{
                            fmt(vatDetailTotals.grandTotal) }} {{ doc.currency }}</div>
                    </div>
                </v-card>

                <div class="text-caption grey--text mt-3 text-center">
                    <v-icon x-small color="grey">mdi-information-outline</v-icon>
                    VAT คำนวณเฉพาะรายการที่เลือกคิด VAT
                </div>

                <v-card-actions class="mt-4 px-0">
                    <v-spacer></v-spacer>
                    <v-btn color="#1565C0" dark rounded elevation="0" width="120"
                        @click="showVatDetailDialog = false">ปิด</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import api from "@/services/api";
import { server, quotationUrl } from "@/services/constants";
import AddProductDialog from "./AddProductDialog.vue";
import Swal from "sweetalert2";
import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
    name: "QuotationForm",
    components: { AddProductDialog, PdfPreviewDialog },
    data() {
        return {
            pdfBlob: null,
            pdfObj: null,
            dialogPDF: false,
            currency_list: [],
            menuPoDate: false,
            menuDeliveryDate: false,
            dialogDelete: false,
            showAddProductDialog: false,
            addProductPrefill: "",
            addProductTarget: null, // { type, row }
            rowSeq: 100,
            ADD_NEW_PREFIX: '+ เพิ่ม "',
            ADD_NEW_SUFFIX: '" เป็นสินค้าใหม่',
            dragSrc: null,
            dragOver: null,

            snackbar: { show: false, text: "", color: "success" },

            docType: "fixed",

            doc: {
                client_id: 0,
                doc_no: "",
                status: "Draft",
                doc_date_show: this.getTodayShow(),
                client_code: "",
                client_name: "",
                client_address: "",
                invoice_address: "",
                tax_id: "",
                branch: "",
                payment_term: "0",
                currency: "THB",
                vat_percent: "0.00",
                attention: "",
                contact_position: "",
                po_no: "",
                po_date: "",
                delivery_date: "",
                additional_info: "",
                not_to_exceed_cap: "",
            },

            clientOptions: [],

            masterItems: [],

            fixedRows: [],
            estimateRows: [],
            uploadedFiles: [],
            removedFileIds: [],
            dialogSelectTitle: false,
            dialogSelectClientInfo: "1",
            print_header_list: [
                {
                    id: "1",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates Ltd.",
                },
                {
                    id: "3",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates",
                },
            ],
            suppressDocTypeWatch: false,
            showVatDetailDialog: false,
            vatDetailType: "fixed",
        };
    },
    computed: {
        // เข้าทาง /add-quotation (ไม่มี :id) = โหมดสร้างใหม่ เสมอเป็น Draft ไม่มีปุ่มเลือกสถานะ
        // เข้าทาง /edit-quotation/:id = โหลดสถานะจริงจากเอกสาร (Draft/Submitted/Invoiced/InProgress)
        isEditMode() {
            return !!this.$route.params.id;
        },
        statusLabel() {
            return { Draft: "Draft", Submitted: "Submitted", Invoiced: "Invoiced", InProgress: "In Progress" }[this.doc.status];
        },
        statusColor() {
            return { Draft: "grey", Submitted: "blue", Invoiced: "green", InProgress: "purple" }[this.doc.status];
        },
        isLocked() {
            return this.doc.status === "Submitted"
                || this.doc.status === "Invoiced"
                || this.doc.status === "InProgress";
        },
        headerEditable() {
            return !this.isLocked; // Draft และ Submitted แก้ header ได้
        },
        itemsEditable() {
            return this.doc.status === "Draft"; // แก้รายการได้เฉพาะ Draft
        },
        docTypeEditable() {
            return this.doc.status === "Draft"; // ล็อกทันทีหลัง Submit
        },
        showDelete() {
            // ยังไม่มีเอกสารให้ลบตอนสร้างใหม่ (add-quotation) — โชว์ปุ่ม Delete เฉพาะตอนแก้ไขเอกสารที่มีอยู่แล้ว
            if (!this.isEditMode) return false;
            return !this.isLocked; // ไม่แสดงปุ่มลบเลยเมื่อ Invoiced/InProgress (REQ-2)
        },
        fixedTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.fixedRows.forEach((r) => {
                const lineTotal = (Number(r.qty) || 0) * (Number(r.price) || 0);
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.fixedRows.length,
            };
        },
        estimateTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.estimateRows.forEach((r) => {
                const lineTotal = Number(r.rate) || 0;
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.estimateRows.length,
            };
        },
        vatDetailRows() {
            const rate = Number(this.doc.vat_percent) || 0;
            const rows = this.vatDetailType === "fixed" ? this.fixedRows : this.estimateRows;
            return rows.map((row) => {
                const base = this.vatDetailType === "fixed"
                    ? (Number(row.qty) || 0) * (Number(row.price) || 0)
                    : (Number(row.rate) || 0);
                const vatAmount = row.applyVat ? base * (rate / 100) : 0;
                return { name: row.name || "-", base, applyVat: row.applyVat, vatRate: rate, vatAmount, afterVat: base + vatAmount };
            });
        },
        vatDetailTotals() {
            return this.vatDetailType === "fixed" ? this.fixedTotals : this.estimateTotals;
        },
        allFixedVatSelected() {
            return this.fixedRows.length > 0 && this.fixedRows.every((r) => r.applyVat);
        },
        fixedVatIndeterminate() {
            const checkedCount = this.fixedRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.fixedRows.length;
        },
        allEstimateVatSelected() {
            return this.estimateRows.length > 0 && this.estimateRows.every((r) => r.applyVat);
        },
        estimateVatIndeterminate() {
            const checkedCount = this.estimateRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.estimateRows.length;
        },
    },
    watch: {
        // ตรวจจับตอน AddProductDialog ปิด ไม่ว่าจากปุ่ม "ยกเลิก" หรือ ESC/click outside
        showAddProductDialog(val) {
            if (!val && this.addProductTarget) {
                // ถ้า addProductTarget ยังไม่ถูกเคลียร์ = ปิดโดยไม่ได้กด "บันทึก"
                // (onProductSaved จะ set addProductTarget = null ไปแล้วก่อนหน้านี้ถ้ากด save)
                // ต้องล้าง searchText ของแถวที่ trigger dialog ด้วย ไม่งั้นข้อความเก่าจะค้างในกล่อง
                this.addProductTarget.row.searchText = "";
                this.addProductTarget = null;
            }
        },
        docType(newVal, oldVal) {
            if (this.suppressDocTypeWatch) return;
            if (newVal === oldVal) return;

            const hasFixedData = this.fixedRows.length > 0;
            const hasEstimateData = this.estimateRows.length > 0;

            if (hasFixedData || hasEstimateData) {
                const proceed = window.confirm(
                    "การสลับประเภทเอกสารจะล้างรายการที่กรอกไว้ทั้งหมด ต้องการดำเนินการต่อหรือไม่"
                );
                if (!proceed) {
                    // ยกเลิกการสลับ กลับไปค่าเดิม
                    this.suppressDocTypeWatch = true;
                    this.docType = oldVal;
                    this.$nextTick(() => {
                        this.suppressDocTypeWatch = false;
                    });
                    return;
                }
            }

            this.fixedRows = [];
            this.estimateRows = [];
            this.rowSeq = 100;
            this.doc.not_to_exceed_cap = "";
        },
        '$route.params.id': {
            immediate: false,
            handler(newId, oldId) {
                if (newId !== oldId) {
                    this.reloadPage();
                }
            }
        }
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            // ✅ catch นี้ครอบเฉพาะ auth flow เท่านั้น
            console.error("QuotationForm mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        // ===== โหลดข้อมูลฟอร์ม แยก catch ออกจาก auth =====
        this.$showLoader();
        try {
            await this.loadCurrency();
            await this.loadCustomer();
            await this.loadMaterProductItem();
            if (this.isEditMode) {
                await this.loadQuotationForEdit(this.$route.params.id);
                await this.loadDataFile(this.$route.params.id)
            } else {
                this.doc.status = "Draft";
            }
        } catch (error) {
            // ✅ ไม่เกี่ยวกับ auth — แจ้ง error ตรงๆ ไม่เด้ง login
            console.error("QuotationForm mounted() load data error:", error);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถโหลดข้อมูลฟอร์มได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    beforeDestroy() {
        // เคลียร์ object URL ทั้งหมดตอนออกจากหน้า กัน memory leak
        this.uploadedFiles.forEach((f) => URL.revokeObjectURL(f.url));
    },

    methods: {
        toggleAllVat(type, checked) {
            const rows = type === "fixed" ? this.fixedRows : this.estimateRows;
            rows.forEach((r) => { r.applyVat = checked; });
        },
        openVatDetail(type) {
            this.vatDetailType = type;
            this.showVatDetailDialog = true;
        },
        onPrint() {
            this.dialogSelectTitle = true;
        },
        getFileName() {
            return `Quotation_${this.doc.doc_no || ((this.docType === "fixed" ? "QT-" : "EST-") + "(ออกอัตโนมัติเมื่อบันทึก)")}.pdf`
        },
        async confirmPrint() {
            try {
                const selectedCompany =
                    this.print_header_list.find((c) => c.id === this.dialogSelectClientInfo) ||
                    this.print_header_list[0];

                const header = {
                    company_inv: "L",
                    com_eng_1: selectedCompany.com_eng_1,
                    com_eng_2: selectedCompany.com_eng_2,
                    com_thai: selectedCompany.com_thai,
                    com_add_name: selectedCompany.com_add_name,
                    com_add_no: selectedCompany.com_add_no,
                    com_add_city: selectedCompany.com_add_city,
                    com_add_country: selectedCompany.com_add_country,
                    com_add_tel: selectedCompany.com_add_tel,
                    com_add_email: selectedCompany.com_add_email,
                    com_add_tax_id: selectedCompany.com_add_tax_id,
                    company_display_name: selectedCompany.com_display_name,
                    doc_no: this.doc.doc_no,
                    doc_date: this.doc.doc_date,
                    doc_type: this.docType,
                    customer_name: this.doc.client_name,
                    customer_address: this.doc.client_address,
                    customer_taxid: this.doc.tax_id,
                    attention: this.doc.attention,
                    payment_term: this.doc.payment_term,
                    currency: this.doc.currency,
                    subtotal: this.docType === "fixed" ? this.fixedTotals.total : this.estimateTotals.total,
                    vat_percent: this.doc.vat_percent,
                    vat_base: this.docType === "fixed" ? this.fixedTotals.vatBase : this.estimateTotals.vatBase,
                    no_vat_base: this.docType === "fixed" ? this.fixedTotals.noVatBase : this.estimateTotals.noVatBase,
                    vat_amount: this.docType === "fixed" ? this.fixedTotals.vat : this.estimateTotals.vat,
                    grand_total: this.docType === "fixed" ? this.fixedTotals.grandTotal : this.estimateTotals.grandTotal,
                    amount_in_words: "",
                    not_to_exceed_cap: this.doc.not_to_exceed_cap,
                    additional_info: this.doc.additional_info,
                };

                const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
                const items = sourceRows.map((row) => ({
                    description: row.name,
                    detail: row.detail,
                    apply_vat: !!row.applyVat,
                    amount: this.docType === "fixed" ? (row.qty || 0) * (row.price || 0) : undefined,
                    rate: this.docType === "estimate" ? this.fmt(row.rate) : undefined,
                }));

                //ฟังก์ชันปริ้นเก่า
                // await pdfQuotationGenerator.exportToPDF({ header, items });

                //ฟังก์ชันปริ้นใหม่
                const blob = await pdfQuotationGenerator.exportToPDF({ header, items });
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
            } catch (error) {
                this.dialogSelectTitle = false;
                console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
            }
        },
        async reloadPage() {
            this.$showLoader();
            try {
                await this.loadCurrency();
                await this.loadCustomer();
                await this.loadMaterProductItem();
                if (this.isEditMode) {
                    await this.loadQuotationForEdit(this.$route.params.id);
                }
            } catch (error) {
                console.error("reloadPage error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                this.$hideLoader();
            }
        },
        async loadCurrency() {
            const res_cur = await api.getDataCurrency();
            this.currency_list = res_cur.data;
        },
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: {
                    company_id: localStorage.getItem(server.COMPANYID),
                },
            });

            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                code: item.cust_account,
                name: item.name,
                address: item.address,
                tax_id: item.taxid,
                branch: item.branch,
                address_invoice: item.address_invoice,
                payment_term: item.payment_term,
                currency: item.currency,
                vat: item.vat,
                contact_position: item.contact_position,
                attention: item.contact_name,
            }));
        },
        async loadMaterProductItem() {
            const res = await api.billing_expense_getInvTitleByDep(localStorage.getItem(server.DEPARTMENT_ID));

            this.masterItems = res.data.map((item) => ({
                name: item.title,
                unit: item.unit,
                rate: Number(item.price),
            }));
        },
        async loadQuotationForEdit(id) {
            try {
                const res = await api.billing_expense_getAllQuotationsByID(id);
                const record = res.data;
                console.log(record)
                if (!record) {
                    await Swal.fire({
                        icon: "error",
                        title: "ไม่พบเอกสาร",
                        text: "ไม่พบเอกสารที่ต้องการแก้ไข",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                    return;
                }

                this.doc = {
                    ...this.doc,
                    quotation_id: record.quotation_id,
                    doc_no: record.doc_no,
                    status: record.status,
                    doc_date_show: this.formatDocDateShow(record.doc_date),
                    client_id: record.client_id,
                    client_address: record.client_address,
                    payment_term: String(record.payment_term ?? "0"),
                    currency: record.currency,
                    vat_percent: String(record.vat_percent ?? "0"),
                    attention: record.attention,
                    contact_position: record.contact_position,
                    po_no: record.po_no,
                    po_date: record.po_date,
                    delivery_date: record.delivery_date,
                    additional_info: record.additional_info,
                    not_to_exceed_cap: record.not_to_exceed_cap != null ? String(record.not_to_exceed_cap) : "",
                };

                // ✅ ป้องกัน watcher docType เคลียร์ rows ที่กำลังจะ map เข้ามาด้านล่าง
                this.suppressDocTypeWatch = true;
                this.docType = record.doc_type; // "fixed" | "estimate"

                // ✅ เพิ่มกลับเข้ามา — ค้นหา client จาก clientOptions แล้วเติมค่าเข้าฟอร์ม
                const clientMatch = this.clientOptions.find(
                    (c) => Number(c.id) === Number(record.client_id)
                );

                if (clientMatch) {
                    this.doc.client_code = clientMatch.code;
                    this.doc.client_name = clientMatch.name;
                    this.doc.invoice_address = clientMatch.address_invoice;
                    this.doc.tax_id = clientMatch.tax_id;
                    this.doc.branch = clientMatch.branch;
                } else if (record.client) {
                    // fallback: ลูกค้าอาจถูกปิดใช้งาน ไม่อยู่ใน active list แต่ backend include client มาด้วย
                    this.doc.client_code = "";
                    this.doc.client_name = record.client.name || "";
                    console.warn(`Client id ${record.client_id} ไม่พบใน active client list`);
                }

                const items = record.items || [];
                if (this.docType === "fixed") {
                    this.fixedRows = items.map((item) => ({
                        id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                        qty: item.qty != null ? Number(item.qty) : 0, unit: item.unit || "",
                        price: item.unit_price != null ? Number(item.unit_price) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                    this.estimateRows = [];
                } else {
                    this.estimateRows = items.map((item) => ({
                        id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                        rate: item.line_total != null ? Number(item.line_total) : "",
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                    this.fixedRows = [];
                }

                const maxId = Math.max(0, ...items.map((i) => i.item_row_id || 0));
                this.rowSeq = Math.max(this.rowSeq, maxId);

                // ✅ คืนค่า flag กลับหลัง map ข้อมูลเสร็จ ให้ watcher ทำงานปกติตอน user สลับ toggle ต่อไป
                this.$nextTick(() => {
                    this.suppressDocTypeWatch = false;
                });

            } catch (error) {
                console.error("loadQuotationForEdit error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลเอกสารได้",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
            }
        },
        async loadDataFile(id) {
            try {
                const res = await api.billing_expense_load_file(id, Number(localStorage.getItem(server.COMPANYID)));
                const files = res.data || [];

                // ✅ Map ไฟล์ที่มีอยู่แล้วในระบบ (จาก backend) เข้า uploadedFiles
                // เพื่อให้แสดงผลใน file-list เหมือนไฟล์ที่เพิ่ง upload ใหม่
                this.uploadedFiles = files.map((f) => ({
                    id: `existing_${f.id}`,       // prefix กันชนกับไฟล์ใหม่ที่ใช้ Date.now()
                    fileId: f.id,                  // เก็บ id จริงจาก backend ไว้ใช้ตอนลบ/อ้างอิง
                    file: null,                    // ไฟล์นี้อยู่บน server แล้ว ไม่มี File object ดิบในเบราว์เซอร์
                    name: f.file_name,
                    url: `${server.API_URL}/billing-expense/quotations/file/${f.id}`, // ปรับตาม endpoint จริงที่ backend ใช้เสิร์ฟไฟล์
                    isExisting: true,              // flag บอกว่าเป็นไฟล์เดิม ไม่ใช่ไฟล์ใหม่ที่รอ upload
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        getTodayShow() {
            const now = new Date();
            const bkkTime = new Date(now.getTime() + 7 * 60 * 60 * 1000);
            const dd = String(bkkTime.getUTCDate()).padStart(2, "0");
            const mm = String(bkkTime.getUTCMonth() + 1).padStart(2, "0");
            const yyyy = bkkTime.getUTCFullYear();
            return `${dd}/${mm}/${yyyy}`;
        },
        formatDateShow(isoDate) {
            if (!isoDate) return "";
            const d = new Date(isoDate);
            if (isNaN(d.getTime())) return "";
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();
            return `${dd}/${mm}/${yyyy}`;
        },
        onFileSelected(e) {
            const files = Array.from(e.target.files || []);
            const rejected = [];

            files.forEach((file) => {
                // อนุญาตเฉพาะไฟล์ PDF เท่านั้น เช็คทั้ง MIME type และนามสกุลไฟล์ (กันเคส MIME type ไม่ถูกต้องจากบาง OS)
                const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
                if (!isPdf) {
                    rejected.push(file.name);
                    return;
                }

                const sanitizedName = this.sanitizeFileName(file.name);
                const uniqueName = this.getUniqueFileName(sanitizedName);

                // ✅ สร้าง File object ใหม่ด้วยชื่อที่ unique แล้ว แทนที่จะใช้ file เดิม
                // เพื่อให้ไฟล์จริงที่จะส่งไป backend มีชื่อตรงกับที่แสดงบน UI (กันชื่อไฟล์ชนกันจริงๆ ตอนอัพโหลด)
                const renamedFile = new File([file], uniqueName, {
                    type: file.type,
                    lastModified: file.lastModified,
                });

                const url = URL.createObjectURL(renamedFile);
                this.uploadedFiles.push({
                    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
                    file: renamedFile, // ✅ เก็บไฟล์ที่ถูกเปลี่ยนชื่อแล้วจริงๆ
                    name: uniqueName,
                    url,
                });
            });

            if (rejected.length > 0) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: `รองรับเฉพาะไฟล์ PDF เท่านั้น: ${rejected.join(", ")}`,
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            }

            e.target.value = "";
        },
        sanitizeFileName(originalName) {
            const dotIdx = originalName.lastIndexOf(".");
            const base = dotIdx > -1 ? originalName.slice(0, dotIdx) : originalName;
            const ext = dotIdx > -1 ? originalName.slice(dotIdx) : "";

            const sanitizedBase = base
                .replace(/[^a-zA-Z0-9ก-๙._-]+/g, "_")   // แทนที่ space/อักขระพิเศษด้วย _
                .replace(/_+/g, "_")                      // ยุบ _ ติดกันหลายตัวให้เหลือตัวเดียว
                .replace(/^_+|_+$/g, "");                 // ตัด _ นำหน้า/ท้ายทิ้ง

            return `${sanitizedBase || "file"}${ext.toLowerCase()}`; // กันเคสชื่อว่างเปล่าหลัง sanitize
        },

        getUniqueFileName(originalName) {
            const existingNames = new Set(this.uploadedFiles.map((f) => f.name));
            if (!existingNames.has(originalName)) return originalName;

            const dotIdx = originalName.lastIndexOf(".");
            const base = dotIdx > -1 ? originalName.slice(0, dotIdx) : originalName;
            const ext = dotIdx > -1 ? originalName.slice(dotIdx) : "";

            let counter = 1;
            let candidate = `${base}_${counter}${ext}`;
            while (existingNames.has(candidate)) {
                counter += 1;
                candidate = `${base}_${counter}${ext}`;
            }
            return candidate;
        },

        // เปิดไฟล์ preview ในแท็บใหม่
        previewFile(f) {
            let fileUrl = f.url;

            // ถ้าเป็นไฟล์เดิมที่โหลดจาก server ใช้ pattern URL ตามที่กำหนด
            if (f.isExisting) {
                fileUrl = `${quotationUrl}/${this.$route.params.id}/${f.name}`;
            }

            const previewWindow = window.open("", "_blank");

            if (!previewWindow) {
                Swal.fire({
                    icon: "warning",
                    title: "แจ้งเตือน",
                    text: "เบราว์เซอร์บล็อก popup กรุณาอนุญาตเปิดแท็บใหม่",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return;
            }

            // เขียน HTML เข้าไปในแท็บใหม่โดยตรง — address bar จะแสดงแค่ about:blank ไม่โชว์ URL ไฟล์จริง
            previewWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>${f.name}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { height: 100vh; display: flex; flex-direction: column; font-family: sans-serif; }
                .toolbar {
                    padding: 8px 16px;
                    background: #fafafa;
                    border-bottom: 1px solid #e0e0e0;
                    display: flex;
                    align-items: center;
                }
                .toolbar button {
                    padding: 6px 16px;
                    border: 1px solid #90a4ae;
                    background: #fff;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;
                }
                .toolbar button:hover { background: #f0f0f0; }
                .frame-wrap { flex: 1; }
                iframe { width: 100%; height: 100%; border: none; }
            </style>
        </head>
        <body>
            <div class="toolbar">
                <button onclick="window.close()">← Back</button>
            </div>
            <div class="frame-wrap">
                <iframe src="${fileUrl}"></iframe>
            </div>
        </body>
        </html>
    `);
            previewWindow.document.close();
        },

        removeFile(id) {
            const idx = this.uploadedFiles.findIndex((f) => f.id === id);
            if (idx === -1) return;

            const target = this.uploadedFiles[idx];

            if (target.isExisting) {
                this.removedFileIds.push({
                    module_name: "Quotation",
                    module_id: this.$route.params.id,
                    file_id: target.fileId,
                    filename: target.name,
                });
            } else {
                URL.revokeObjectURL(target.url);
            }

            this.uploadedFiles.splice(idx, 1);
        },
        getBackList() {
            this.$router.push("/quotation-list");
        },
        fmt(n) {
            return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        onClientSelect(value, key = "code") {
            const c =
                key === "code"
                    ? this.clientOptions.find((x) => x.code === value)
                    : this.clientOptions.find((x) => x.name === value);

            if (c) {
                this.doc.client_id = c.id
                this.doc.client_code = c.code;
                this.doc.client_name = c.name;
                this.doc.client_address = c.address;
                this.doc.invoice_address = c.address_invoice;
                this.doc.tax_id = c.tax_id;
                this.doc.branch = c.branch;
                this.doc.payment_term = c.payment_term;
                this.doc.currency = c.currency; // ← เพิ่มเงื่อนไข fallback
                this.doc.vat_percent = c.vat;
                this.doc.contact_position = c.contact_position;
                this.doc.attention = c.attention;
            } else {
                this.doc.client_code = "";
                this.doc.client_name = "";
                this.doc.client_address = "";
                this.doc.invoice_address = "";
                this.doc.tax_id = "";
                this.doc.branch = "";
                this.doc.payment_term = "0";
                this.doc.currency = "THB";

                this.doc.vat_percent = "";
                this.doc.contact_position = "";
                this.doc.attention = "";
            }
        },

        filterMaster(text) {
            const t = (text || "").toString().trim().toLowerCase();
            const original = (text || "").toString().trim();
            if (!t) return this.masterItems.map((m) => m.name);
            const matches = this.masterItems.filter((m) => m.name.toLowerCase().includes(t)).map((m) => m.name);
            if (matches.length === 0 && original) {
                return [`${this.ADD_NEW_PREFIX}${original}${this.ADD_NEW_SUFFIX}`];
            }
            return matches;
        },
        // เช็คว่า item ที่ render อยู่ใน dropdown เป็นตัวเลือก "+ เพิ่มสินค้าใหม่" หรือเปล่า (ใช้แต่งสีฟ้า)
        isAddNewItem(item) {
            return (
                typeof item === "string" &&
                item.startsWith(this.ADD_NEW_PREFIX) &&
                item.endsWith(this.ADD_NEW_SUFFIX)
            );
        },
        onNameInput(type, row, val) {
            if (
                typeof val === "string" &&
                val.startsWith(this.ADD_NEW_PREFIX) &&
                val.endsWith(this.ADD_NEW_SUFFIX)
            ) {
                const typed = val.slice(this.ADD_NEW_PREFIX.length, val.length - this.ADD_NEW_SUFFIX.length);
                row.name = "";
                this.openAddProduct(type, row, typed);
                return;
            }
            row.name = val;
            const found = this.masterItems.find((m) => m.name === val);
            if (found) {
                if (type === "fixed") {
                    row.unit = found.unit;
                    row.price = found.rate;   // <-- เพิ่ม: auto-fill ราคาต่อหน่วย
                } else {
                    row.rate = found.rate;    // <-- เพิ่ม: auto-fill ราคาสำหรับ estimate
                }
            }
        },
        // Note 21: กด Enter เฉยๆ ย้าย focus ไปแถวถัดไป (หรือเพิ่มแถวใหม่ถ้าเป็นแถวสุดท้าย)
        // กด Shift+Enter ขึ้นบรรทัดใหม่ในช่องรายละเอียดตามปกติ
        onDetailKeydown(e, type, row) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
                const idx = arr.findIndex((r) => r.id === row.id);
                const next = arr[idx + 1];
                if (next) {
                    this.$nextTick(() => {
                        const el = document.querySelector(`tr[data-row-id="${type}-${next.id}"] .item-picker input`);
                        if (el) el.focus();
                    });
                } else {
                    this.addRow(type);
                }
            }
        },
        addRow(type) {
            this.rowSeq += 1;
            if (type === "fixed") {
                this.fixedRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", qty: 1, unit: "", price: 0, applyVat: true });
            } else {
                this.estimateRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", rate: "", applyVat: true });
            }
        },
        delRow(type, id) {
            if (type === "fixed") this.fixedRows = this.fixedRows.filter((r) => r.id !== id);
            else this.estimateRows = this.estimateRows.filter((r) => r.id !== id);
        },
        // ---- Add Product modal ----
        openAddProduct(type, row, prefill) {
            this.addProductTarget = { type, row };
            this.addProductPrefill = prefill || "";
            this.showAddProductDialog = true;
        },
        async onProductSaved(product) {
            // เติมค่าลงแถวที่ trigger dialog ทันที ไม่ต้องรอ API โหลด masterItems ใหม่
            // กันปัญหา field ว่างค้างระหว่างรอ network (dialog ปิดไปแล้วตั้งแต่ก่อน onProductSaved ทำงานเสร็จ)
            if (this.addProductTarget) {
                const { type, row } = this.addProductTarget;
                row.name = product.name;
                row.searchText = product.name; // sync search text ให้ตรงกับชื่อที่เพิ่งเลือก ไม่ให้ค้างข้อความเก่า
                if (type === "fixed") {
                    row.unit = product.unit;
                    row.price = product.rate;
                } else {
                    row.rate = product.rate;
                }
            }
            this.addProductTarget = null;

            // โหลด masterItems ใหม่แบบ background เพื่อให้ dropdown ครั้งถัดไปมีตัวเลือกล่าสุดจาก backend
            // ไม่ต้อง await ก่อนแสดงผลแถว เพราะแถวถูกเติมค่าไปแล้วด้านบน
            try {
                await this.loadMaterProductItem();
            } catch (error) {
                console.error("loadMaterProductItem error:", error);
            }
        },
        // ---- Drag & drop reorder ----
        onDragStart(type, id) {
            this.dragSrc = { type, id };
        },
        onDragOver(type, id) {
            if (!this.dragSrc || this.dragSrc.type !== type) return;
            this.dragOver = id;
        },
        onDrop(type, id) {
            if (!this.dragSrc || this.dragSrc.type !== type || this.dragSrc.id === id) return;
            const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
            const fromIdx = arr.findIndex((r) => r.id === this.dragSrc.id);
            const toIdx = arr.findIndex((r) => r.id === id);
            const [moved] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, moved);
            this.dragSrc = null;
            this.dragOver = null;
        },
        onDragEnd() {
            this.dragSrc = null;
            this.dragOver = null;
        },
        dragRowClass(type, id) {
            return this.dragOver === id && this.dragSrc && this.dragSrc.type === type ? "drop-target" : "";
        },
        // ---- Validation / Save / Submit / Delete ----
        validateBeforeSubmit() {
            if (!this.doc.client_code) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "กรุณาเลือก Client ก่อน Submit",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return false;
            }
            const rows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            if (rows.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "กรุณาเพิ่มรายการอย่างน้อย 1 รายการ",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return false;
            }
            return true;
        },
        // แปลง "" / undefined / null เป็น null สำหรับ field ตัวเลข กัน "invalid input syntax for type numeric"
        toNullableNumber(val) {
            if (val === "" || val === undefined || val === null) return null;
            const n = Number(val);
            return isNaN(n) ? null : n;
        },

        // แปลงวันที่ว่างเปล่า/parse ไม่ได้ เป็น null กัน "invalid input syntax for type date"
        toNullableDate(val) {
            if (!val || val === "" || val === "Invalid date") return null;
            const d = new Date(val);
            if (isNaN(d.getTime())) return null;
            return val; // v-date-picker คืนเป็น "YYYY-MM-DD" อยู่แล้ว ส่งตรงได้ถ้า valid
        },

        // แปลง "" / undefined เป็น null สำหรับ field ข้อความที่เป็น optional (nullable ใน DB)
        toNullableString(val) {
            return val === "" || val === undefined ? null : val;
        },

        // ปัดเศษทศนิยม 2 ตำแหน่งตามหลักคณิตศาสตร์ (round half up) กัน floating point error
        round2(num) {
            const n = Number(num) || 0;
            return Math.round((n + Number.EPSILON) * 100) / 100;
        },
        getTodayDateOnly() {
            const now = new Date();
            const bkkTime = new Date(now.getTime() + 7 * 60 * 60 * 1000);
            const yyyy = bkkTime.getUTCFullYear();
            const mm = String(bkkTime.getUTCMonth() + 1).padStart(2, "0");
            const dd = String(bkkTime.getUTCDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },

        async onSaveDraft() {
            if (!this.validateBeforeSubmit()) return;

            await this.saveQuotation('Draft');
        },


        async onSubmit() {
            // ✅ ต้องเช็คก่อนเสมอ ห้ามแก้ตารางแล้วข้อมูลไม่ครบหลุดเข้าไปเป็น Submitted
            if (!this.validateBeforeSubmit()) return;

            if (this.docType === "fixed" && this.fixedTotals.grandTotal === 0) {
                // Edge case: Grand Total = 0 — ต้องให้ผู้ใช้ยืนยันก่อน เพราะหลัง Submit แก้ไขรายการไม่ได้แล้ว
                if (!window.confirm("ยอดรวมเป็น 0 ต้องการดำเนินการต่อหรือไม่")) return;
            }

            await this.saveQuotation('Submitted');
        },

        async saveQuotation(status) {
            var dataItem = {
                doc_type: this.docType,
                status: status, // ✅ ส่วนต่างเดียวระหว่าง Draft กับ Submit
                client_id: Number(this.doc.client_id),
                client_address: this.doc.client_address,
                payment_term: this.doc.payment_term,
                currency: this.doc.currency,
                vat_percent: Number(this.doc.vat_percent),
                attention: this.doc.attention,
                contact_position: this.doc.contact_position,
                po_no: this.doc.po_no,
                po_date: this.toNullableDate(this.doc.po_date),
                delivery_date: this.toNullableDate(this.doc.delivery_date),
                additional_info: this.doc.additional_info,
                subtotal: 0,
                vat_amount: 0,
                grand_total: 0,
                not_to_exceed_cap: 0,
                user_update: Number(localStorage.getItem(server.USER_ID)),
                company_id: Number(localStorage.getItem(server.COMPANYID)),
                department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
            };

            if (this.docType == "fixed") {
                dataItem.subtotal = this.round2(this.fixedTotals.total);
                dataItem.vat_amount = this.round2(this.fixedTotals.vat);
                dataItem.grand_total = this.round2(this.fixedTotals.grandTotal);
            } else if (this.docType == "estimate") {
                dataItem.subtotal = this.round2(this.estimateTotals.total);
                dataItem.vat_amount = this.round2(this.estimateTotals.vat);
                dataItem.grand_total = this.round2(this.estimateTotals.grandTotal);
                dataItem.not_to_exceed_cap = Number(this.doc.not_to_exceed_cap);
            } else {
                return;
            }

            const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            const buildItemsPayload = (quotationId) =>
                sourceRows.map((row, idx) => {
                    const base = {
                        quotation_id: quotationId,
                        seq_no: idx + 1,
                        item_name: row.name || "",
                        detail: this.toNullableString(row.detail),
                        apply_vat: !!row.applyVat,                              // ✅ ใหม่
                        vat_rate: row.applyVat ? Number(this.doc.vat_percent) : null,
                    };
                    if (this.docType === "fixed") {
                        const qty = this.toNullableNumber(row.qty);
                        const unitPrice = this.toNullableNumber(row.price);
                        return {
                            ...base,
                            qty, unit: this.toNullableString(row.unit), unit_price: unitPrice,
                            line_total: this.round2((qty || 0) * (unitPrice || 0)),
                        };
                    } else {
                        return {
                            ...base,
                            qty: null, unit: null, unit_price: null,
                            line_total: this.toNullableNumber(row.rate),
                        };
                    }
                });

            const isEdit = !!this.$route.params.id;
            const successTitle = status === 'Draft'
                ? (isEdit ? "บันทึกสำเร็จ" : "เพิ่มสำเร็จ")
                : "Submit สำเร็จ";
            const successText = status === 'Draft'
                ? (isEdit ? "บันทึกการแก้ไข Draft เรียบร้อยแล้ว" : "เพิ่มใบเสนอราคาเรียบร้อยแล้ว")
                : "ส่งเอกสารเรียบร้อยแล้ว รายการถูกล็อกแล้ว";

            this.$showLoader(); // ✅ เริ่มโหลดก่อนยิง API

            // ===== โหมดแก้ไข (Edit) =====
            if (isEdit) {
                const editId = this.$route.params.id;

                try {

                    if (!this.doc.doc_no || this.doc.doc_no.trim() == "") {
                        dataItem.modeUpdate = "updateStatus";
                    } else {
                        dataItem.modeUpdate = "updateData";
                    }

                    const res_update = await api.billing_expense_updateQuotations(editId, dataItem);

                    if (res_update.status == 200) {
                        const itemsPayload = buildItemsPayload(Number(editId));

                        try {
                            await api.billing_expense_deleteQuotationsItem(editId);
                            if (itemsPayload.length > 0) {
                                await api.billing_expense_addQuotationsItem(itemsPayload);
                            }

                            // ✅ ลบไฟล์เดิมที่ผู้ใช้กด remove ไว้ (ยิงตอนนี้ก่อน Save จริง)
                            for (const removed of this.removedFileIds) {
                                await api.billing_expense_delete_file(removed); // removed = { module_name, module_id, file_id, filename }
                            }
                            this.removedFileIds = [];

                            // ✅ อัพโหลดเฉพาะไฟล์ใหม่ที่ยังไม่มี isExisting (ไฟล์เดิมไม่ต้อง upload ซ้ำ)
                            const newFiles = this.uploadedFiles.filter((f) => !f.isExisting);
                            for (const item of newFiles) {
                                let formData = new FormData();
                                formData.append("file", item.file);
                                formData.append("id", Number(this.$route.params.id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));

                                await api.billing_expense_upload_file(formData);
                            }

                            await this.loadQuotationForEdit(editId);
                            await this.loadDataFile(editId);
                            this.$hideLoader();

                            await Swal.fire({
                                icon: "success",
                                title: successTitle,
                                text: successText,
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true,
                            });

                        } catch (errorItems) {
                            console.error("update items error:", errorItems);
                            this.$hideLoader();
                            await Swal.fire({
                                icon: "error",
                                title: "เกิดข้อผิดพลาด",
                                text: "บันทึก Header สำเร็จ แต่บันทึกรายการล้มเหลว กรุณาลองใหม่อีกครั้ง",
                                showConfirmButton: false,
                                timer: 2500,
                                timerProgressBar: true,
                            });
                        }
                    }
                } catch (error) {
                    console.error("updateQuotations error:", error);
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }

            } else {
                // ===== โหมดสร้างใหม่ (Create) — ใช้ได้กับปุ่ม Save Draft เท่านั้น เพราะปุ่ม Submit ไม่โชว์ตอนสร้างใหม่ (v-if="isEditMode") =====
                dataItem.doc_date = this.getTodayDateOnly();
                dataItem.doc_no = this.toNullableString(this.doc.doc_no);
                dataItem.user_create = Number(localStorage.getItem(server.USER_ID));

                try {
                    const res_add = await api.billing_expense_addQuotations(dataItem);

                    if (res_add.status == 201) {
                        var main_id = Number(res_add.data.quotation_id);
                        const itemsPayload = buildItemsPayload(main_id);

                        try {
                            for (const item of this.uploadedFiles) {
                                let formData = new FormData();
                                formData.append("file", item.file); // item.file คือ File object ดิบที่เก็บไว้ตอน onFileSelected
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));

                                await api.billing_expense_upload_file(formData);
                            }

                            const res_items = await api.billing_expense_addQuotationsItem(itemsPayload);

                            if (res_items.status == 201) {
                                this.uploadedFiles = []
                                await this.loadDataFile(Number(main_id));
                                this.$hideLoader();
                                await Swal.fire({
                                    icon: "success",
                                    title: successTitle,
                                    text: successText,
                                    showConfirmButton: false,
                                    timer: 2000,
                                    timerProgressBar: true,
                                });
                                this.$router.push(`/edit-quotation/${main_id}`);
                            }
                        } catch (errorItems) {
                            console.error("addQuotationsItem error:", errorItems);
                            this.$hideLoader();
                            await Swal.fire({
                                icon: "error",
                                title: "เกิดข้อผิดพลาด",
                                text: `บันทึก Header สำเร็จ (เลขที่ ${res_add.data.doc_no}) แต่บันทึกรายการล้มเหลว กรุณาแก้ไขเอกสารนี้อีกครั้ง`,
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                            });
                            this.$router.push(`/edit-quotation/${main_id}`);
                        }
                    }
                } catch (error) {
                    console.error("addQuotations error:", error);
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            }
        },
        async confirmDelete() {
            const id = this.$route.params.id;
            this.dialogDelete = false; // ปิด dialog ยืนยันก่อน แล้วค่อยแสดง loader
            this.$showLoader();

            try {
                const res = await api.billing_expense_updateQuotations(id, { is_deleted: true, modeUpdate: "deleteData" });

                if (res.status == 200) {
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: "ลบสำเร็จ",
                        text: "ลบใบเสนอราคาเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                }
            } catch (error) {
                console.error("confirmDelete error:", error);
                this.$hideLoader();
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: error.response?.data?.message || "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            }
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

};
</script>

<style scoped>
.bg-colorth {
    background-color: #595959;
}

.texttablehcenter {
    color: #fff !important;
    text-align: center;
}

.drag-handle {
    cursor: grab;
    color: #90a4ae;
    text-align: center;
}

.drop-target {
    box-shadow: inset 0 2px 0 #1565c0;
}

.detail-input>>>textarea {
    font-size: 12px;
    color: #1565c0;
}

.item-picker {
    position: relative;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
    background-color: #1d2442;
    color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
    background-color: #9e3b1b;
    color: white;
}

.heightsize70formadvance {
    height: 70px;
}

.heightsize55formadvance {
    height: 55px;
}

.btnuploadfile {
    border: 2px solid;
}

.hover-back:hover {
    text-decoration: underline;
}

/* ปุ่ม toggle ประเภทเอกสาร ตอนเลือกอยู่ = สีม่วง ตรงกับ wireframe (.doctype-pill active #6A1B9A) */
.doctype-toggle>>>.v-btn--active {
    background-color: #6a1b9a !important;
    color: #fff !important;
}

.doctype-toggle>>>.v-btn--active::before {
    opacity: 0;
}

/* Alert boxes — สีตรงกับ wireframe ต้นฉบับเป๊ะ (.alert-info / .alert-warn) */
.wf-alert {
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 13px;
    margin-bottom: 14px;
}

.wf-alert-info {
    background: #e3f2fd;
    color: #0d47a1;
    border-left: 4px solid #1565c0;
}

.wf-alert-warn {
    background: #fff3e0;
    color: #e65100;
    border-left: 4px solid #ef6c00;
}

.file-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.file-card {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 6px 6px 6px 12px;
    max-width: 260px;
    transition: box-shadow 0.15s, border-color 0.15s;
}

.file-card:hover {
    border-color: #90caf9;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.file-card-main {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    overflow: hidden;
    flex: 1;
    min-width: 0;
}

.file-card-name {
    font-size: 13px;
    color: #1565c0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-card-delete {
    margin-left: 6px;
    flex-shrink: 0;
}

.file-card-delete .v-icon {
    color: #b0bec5;
}

.file-card-delete:hover .v-icon {
    color: #e53935;
}

.summary-card {
    border-radius: 8px;
    background: #fff;
}

/* ✅ กล่องพื้นฐานที่ใช้ร่วมกันทั้ง 3 แถว padding เท่ากันหมด ระยะเริ่มต้นข้อความตรงกัน */
.summary-row {
    padding: 10px 12px;
    border-radius: 6px;
}

/* ✅ แถวสุดท้ายทับสีพื้นหลังฟ้าเพิ่ม แต่ padding เท่าเดิมจาก .summary-row */
.summary-total-box {
    background: #e3f2fd;
}

.summary-label {
    flex: 1;
    min-width: 0;
}

.summary-value {
    flex-shrink: 0;
    text-align: right;
    white-space: nowrap;
    margin-left: 12px;
}

.summary-title {
    font-size: 25px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
}

.vat-detail-link {
    color: #1565c0;
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
}

.vat-detail-link:hover {
    color: #0d47a1;
}

.vat-dialog-card {
    border-radius: 16px;
}

.vat-table-card {
    border-radius: 8px;
    overflow: hidden;
}

.vat-detail-table th {
    font-weight: 600;
    color: #424242;
    background: #FAFAFA;
    font-size: 12.5px;
}

.vat-detail-table td {
    font-size: 13.5px;
}

.vat-summary-card {
    font-size: 13px;
}

.vat-summary-card .summary-row {
    padding: 8px 10px;
}

.vat-grand-total {
    font-size: 18px;
}

.vat-detail-table {
    border-collapse: collapse;
}

.vat-detail-table th,
.vat-detail-table td {
    border-right: 1px solid #E0E0E0;
}

.vat-detail-table th:last-child,
.vat-detail-table td:last-child {
    border-right: none;
}

.select-all-checkbox {
    display: inline-flex;
}

.select-all-checkbox>>>label {
    color: #fff !important;
    font-size: 10px !important;
}

.vat-switch-cell {
    vertical-align: middle;
}

.vat-switch {
    margin-top: 0 !important;
    padding-top: 0 !important;
    display: flex;
    align-items: center;
}

.vat-switch>>>.v-input__slot {
    margin-bottom: 0;
}

.vat-switch>>>.v-messages {
    display: none;
}

.vat-switch>>>label {
    font-size: 11px !important;
    margin-left: 4px;
}

.summary-label {
    flex: 1;
    min-width: 0;
    font-size: 14px;
}
</style>